export const parseCustomerAsOption = (rawCustomerArray: any[]): any[] => (rawCustomerArray.map((eachCustomer) => ({ value: eachCustomer.Nombre })));
